// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2tFHh","footer":"ModalError_footer__Lv4ue"};